import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Modal } from 'antd';
import { BulbTwoTone, UnlockTwoTone, ImportOutlined, LoginOutlined, DoubleRightOutlined, QuestionCircleOutlined, UserAddOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import Layout, { Content, Footer, Header } from 'antd/lib/layout/layout'
import { _Button } from '../services/Forms/Forms';
import { globalText } from '../services/Text/GlobalText';
import { acakText } from '../services/Crypto';
// import _Api from '../services/Api/_ApiBase';
import { _Toastr } from '../services/Toastr/Notify/_Toastr';
import { logo, LogOut } from '.';
// import _ApiBase from '../services/Api/_ApiBase';
import axios from 'axios';
import { baseURL_R } from '../services/BaseUrl';
import MainLayouts from '../layouts/MainLayouts';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
// import logo from "../assets/img/logo1.png"

// import logo from "/assets/img/logo.png"


function AttemptAuth() {

    const [username, setUsername] = useState()
    const [password, setpassword] = useState()
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const history = useHistory()



    useEffect(() => {
        setLoading(false)
        LogOut();
    }, [])

    const gotoRegister = () => {
        history.push("/register-auth")
    }
    const attemptLogin = () => {

        try {


            setLoading(true)
            // window.location.href = "/home";

            let obj = {
                username: username,
                password: password
            }

            axios.post(`${baseURL_R}/auth-do-login`, obj).then(res => {
                const data = res.data;
                if (data.sts == "1") {
                    let user = JSON.stringify(res.data);
                    sessionStorage.setItem(globalText.x_auth_resu, acakText(user))
                    sessionStorage.setItem(globalText.x_auth_user, acakText(res.data.user.role))
                    sessionStorage.setItem(globalText.x_auth_access_token, acakText(data.token))
                    sessionStorage.setItem(globalText.x_auth_refresh_token, acakText(data.refresh_token))
                    sessionStorage.setItem(globalText.authorization, acakText(data.role))
                    // sessionStorage.setItem('token', data.token)
                    window.location.href = "Home";
                    // histori.push("ShowDataPengadaan")
                } else {
                    _Toastr.error("Akses di tolak ...")
                    setLoading(false)
                    return
                }
                // setError(false)
            }).catch(err => {
                setLoading(false)
                _Toastr.error("Gagal terhubung ke server, Periksa jaringan anda ...")

            })
        } catch (error) {
            setLoading(false)
            _Toastr.error("Gagal terhubung ke server, Periksa jaringan anda ...")
        }
    }


    return (
        <MainLayouts >
            <div style={{ width: "100%", padding: "0px 10%" }}>
                <h1 style={{ textAlign: "center", marginTop: "8%" }}></h1>
                <div class="login100-pic js-tilt" data-tilt="data-title">
                        {/* <img src={"/img/logo.png"}/> */}
                    </div>
                <div style={{ textAlign: "center" }}>
                    <p><img width="250" src={logo} alt="" /></p>
                    <p style={{ textAlign: "center", fontWeight: "bolder", fontSize: "20px" }}> <span style={{ color: "#ff4d4f" }}>
                        SILAHKAN </span> LOGIN   </p>

                    {/* <b> Silahkan Login </b> */}
                </div>
                <Layout style={{ alignItems: "center", borderRadius: "0px 25px", background: "#49505730", paddingTop: "30px" }}>

                    <Content style={{ marginLeft: "15px" }}>
                        {/* <LinearProgress indeterminate /> */}
                        <Form onFinish={attemptLogin}
                            layout={"inline"}
                            style={{ color: "white" }}>
                            <Form.Item label="No. HP ::" >
                                <Input style={{ width: "300px" }} prefix={<BulbTwoTone />} onChange={(e) => setUsername(e.target.value)} />
                            </Form.Item>
                            <Form.Item label="Password ::">
                                <Input.Password style={{ width: "300px" }} prefix={<UnlockTwoTone />} onChange={(e) => setpassword(e.target.value)} />
                            </Form.Item>
                            <Form.Item>
                                <_Button
                                    type="primary"
                                    style={{ marginTop: "2px" }}
                                    submit
                                    icon={<ImportOutlined />}
                                    loading={loading}
                                    label="Login"
                                > Login </_Button>
                            </Form.Item>
                        </Form>
                        <br />
                    </Content>
                </Layout>
                <br />
                <center>
                    {/* <Button type="link" icon={<UserAddOutlined />} onClick={gotoRegister} > <b>Buat Akun Disini </b></Button> */}
                    {/* <br /> */}
                    <a href="">    Lupa Password  <QuestionCircleOutlined /> </a>
                </center>
            </div>


        </MainLayouts>

    )
}

export default AttemptAuth
